import { PrinterPosRefreshIcon } from './PrinterPosRefreshIcon';

/**
 * author: Colton Wiscombe
 * id 9C26E188-105E-45DE-A8D3-42DA8829FE34
 * name printer-pos-refresh
 * version: 7.1.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/printer-pos-refresh.svg
 * tags
 * - Printer 
 */
export const PrinterPointOfSaleRefreshIcon = PrinterPosRefreshIcon;
export default PrinterPointOfSaleRefreshIcon